export default {
  'pending': '미@:terms.register',
  'processing': '@:terms.register중',
  'success': '@:terms.register완료',
  'failure': '@:terms.register실패',
  'expired': '만료',
}
